const { Core } = Global;
const ENTER_KEY_IDENTIFIER = 'Enter';

customElements.define('navigator-share', class extends Core {
    propTypes = {
        'share-url': String,
    }

    render() {
        if (!('share' in window.navigator)) return;
        
        this.url = this.prop('share-url') || window.location.href;
        this.$({
            click: this._share,
            keydown: this._handleEnterPress
        });
    }

    _share() {
        window.navigator.share({
            url: this.url,
            title: document.title
        })
    }

    _handleEnterPress(e) {
        if(e.key === ENTER_KEY_IDENTIFIER && e.target === this) {
            e.preventDefault();
            e.stopPropagation();
            this._share()
        }
    }
})
